var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline","padding":"0px","margin":"0px"}},[(_vm.shouldOpenInNewTab || _vm.alwaysA)?[_c('a',{staticClass:"dropdown-item",attrs:{"href":_vm.href,"target":"_blank"}},[_vm._t("default")],2)]:[_c('router-link',{staticClass:"nav-link",attrs:{"to":_vm.href}},[_vm._t("default")],2)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-115a6738","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/display/NavbarLink.vue
// module id = null
// module chunks = 